import { DeleteOutlined } from '@ant-design/icons';
import { useState } from 'react';

import { CardInfoProps } from './payment-methods-types';
import { AppTag, AppButton, AppTypography } from '@/react_app/components/Atoms/index';
const SettingsUsageBillingPaymentMethodsCardInfo = ({
	cardInfo,
	isDefault,
	sectionTitle,
	onDeletePaymentMethod,
	onSetDefaultPaymentMethod,
}: CardInfoProps) => {
	const [isLoadingDelete, setIsLoadingDelete] = useState(false);
	const [isLoadingSetPaymentMethod, setIsLoadingSetPaymentMethod] = useState(false);
	const setDefaultPayment = async () => {
		try {
			setIsLoadingSetPaymentMethod(true);
			await onSetDefaultPaymentMethod();
		} catch (err: unknown) {
			// @ts-ignore
			throw new Error(err);
		} finally {
			setIsLoadingSetPaymentMethod(false);
		}
	};
	const deletePaymentMethod = async () => {
		try {
			setIsLoadingDelete(true);
			await onDeletePaymentMethod();
		} catch (err: unknown) {
			// @ts-ignore
			throw new Error(err);
		} finally {
			setIsLoadingDelete(false);
		}
	};
	return (
		<div>
			<AppTypography.Title level={5}>{sectionTitle}</AppTypography.Title>
			<div className="flex items-center justify-between mb-[13px]">
				<AppTypography.Paragraph className="text-colorText text-[13px] mb-0">
					Card ending in <strong>{cardInfo.last4}</strong>
				</AppTypography.Paragraph>
				{isDefault ? (
					<AppTag>Default</AppTag>
				) : (
					<div>
						<AppButton size="small" className="mr-1" onClick={setDefaultPayment} loading={isLoadingSetPaymentMethod}>
							Set as Default
						</AppButton>
						<AppButton size="small" icon={<DeleteOutlined />} loading={isLoadingDelete} onClick={deletePaymentMethod} />
					</div>
				)}
			</div>
			<AppTypography.Paragraph className="text-colorTextSecondary text-[13px]">{cardInfo.brand}</AppTypography.Paragraph>
			<AppTypography.Paragraph className="text-colorTextSecondary text-[13px]">
				{cardInfo.exp_month}/{cardInfo.exp_year}
			</AppTypography.Paragraph>
			{isDefault && (
				<AppTypography.Paragraph className="text-colorTextTertiary text-[13px]">
					Future payments will be made with this method.
				</AppTypography.Paragraph>
			)}
		</div>
	);
};

export default SettingsUsageBillingPaymentMethodsCardInfo;
